import { createSlice } from "@reduxjs/toolkit";

export const stateSlice = createSlice({
  name: "tarot",
  initialState: {
    name: "",
    gender: "",
    birthDate: {},
    birthPlace: "",
    birthTime: {},
    cards: [],
  },
  reducers: {
    setName: (state, action) => {
      state.name = action.payload;
    },
    setBirthDate: (state, action) => {
      state.birthDate = action.payload;
    },
    setBirthPlace: (state, action) => {
      state.birthPlace = action.payload;
    },
    setBirthTime: (state, action) => {
      state.birthTime = action.payload;
    },
    setGender: (state, action) => {
      state.gender = action.payload;
    },
    setCards: (state, action) => {
      state.cards = action.payload;
    },
  },
});

export const {
  setName,
  setBirthDate,
  setBirthPlace,
  setBirthTime,
  setGender,
  setCards
} = stateSlice.actions;

export default stateSlice.reducer;
